import React from "react";

export class WeightRegular extends React.Component<React.PropsWithChildren<{}>> {
    public render (): JSX.Element {
        return (
            <span className="weight-regular">{this.props.children}</span>
        );
    }
}
